import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import FormCreator from "../../common/FormCreator";
import history from "../../history";
import { postDrivingForm } from "../../redux/actions";

const SkillsAndQualificationsForm = ({ appData, postDrivingFormFunc }) => {
  const initialData = {
    companiesAssessments: {
      0: {},
      1: {},
      2: {},
      3: {},
    },
    ...(appData.drivingOnboarding &&
      appData.drivingOnboarding.skillsAndQualifications),
  };
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const vehicleType = {
    "3st": "3.5T",
    "7st": "7.5T",
    rigid: "Rigid",
    artic: "Artic",
  };

  const operation = {
    continental: "Continental",
    trunking: "Trunking",
    tramping: "Tramping",
    shunting: "Shunting",
    supermarkets: "Supermarkets",
    docks: "Docks",
    airports: "Airports",
    plantHaulage: "Plant haulage",
    multidrop: "Multidrop",
    drayWork: "Dray work",
    tailLift: "Tail lift",
    fridges: "Fridges",
    skips: "Skips",
    ropeAndSheet: "Rope and sheet",
    curtainsiders: "Curtainsiders",
    other: "Other",
  };

  const trailerType = {
    frame: "A frame",
    drawBar: "Draw bar",
    demountables: "Demountables",
    tippers: "Tippers",
    tankers: "Tankers",
    lowLoaders: "Low loaders",
    containers: "Containers",
    tilts: "Tilts",
    bulkers: "Bulkers",
    walkingFloors: "Walking floors",
    flatBed: "Flat bed",
    doubleDeckers: "Double deckers",
  };

  const initialState = {
    skillsAndQualificationsText: {
      htmlObj: (
        <div>
          Please tick the skills and business areas you have experience and
          would like to work.
        </div>
      ),
    },
    vehicleType: {
      title: "Vehicle type",
      value: getVal("vehicleType"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: vehicleType["3st"], value: vehicleType["3st"] },
        { label: vehicleType["7st"], value: vehicleType["7st"] },
        { label: vehicleType.rigid, value: vehicleType.rigid },
        { label: vehicleType.artic, value: vehicleType.artic },
      ],
    },
    operation: {
      title: "Operation",
      value: getVal("operation"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: operation.continental, value: operation.continental },
        { label: operation.trunking, value: operation.trunking },
        { label: operation.tramping, value: operation.tramping },
        { label: operation.shunting, value: operation.shunting },
        { label: operation.supermarkets, value: operation.supermarkets },
        { label: operation.docks, value: operation.docks },
        { label: operation.airports, value: operation.airports },
        { label: operation.plantHaulage, value: operation.plantHaulage },
        { label: operation.multidrop, value: operation.multidrop },
        { label: operation.drayWork, value: operation.drayWork },
        { label: operation.tailLift, value: operation.tailLift },
        { label: operation.fridges, value: operation.fridges },
        { label: operation.skips, value: operation.skips },
        { label: operation.ropeAndSheet, value: operation.ropeAndSheet },
        { label: operation.curtainsiders, value: operation.curtainsiders },
        { label: operation.other, value: operation.other },
      ],
      optionsDetailsInputs: {
        [operation.multidrop]: "noOfDrops",
      },
    },
    noOfDrops: {
      title: "No. of drops",
      value: getVal("noOfDrops"),
      type: "number",
      display: false,
      dependOn: [
        {
          fieldKey: "operation",
          allowedValues: [operation.multidrop],
        },
      ],
    },
    otherOperation: {
      title: "Other operation",
      value: getVal("otherOperation"),
      dependOn: [
        {
          fieldKey: "operation",
          allowedValues: [operation.other],
        },
      ],
    },
    trailerType: {
      title: "Trailer type",
      value: getVal("trailerType"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: trailerType.frame, value: trailerType.frame },
        { label: trailerType.drawBar, value: trailerType.drawBar },
        { label: trailerType.demountables, value: trailerType.demountables },
        { label: trailerType.tippers, value: trailerType.tippers },
        { label: trailerType.tankers, value: trailerType.tankers },
        { label: trailerType.lowLoaders, value: trailerType.lowLoaders },
        { label: trailerType.containers, value: trailerType.containers },
        { label: trailerType.tilts, value: trailerType.tilts },
        { label: trailerType.bulkers, value: trailerType.bulkers },
        { label: trailerType.walkingFloors, value: trailerType.walkingFloors },
        { label: trailerType.flatBed, value: trailerType.flatBed },
        { label: trailerType.doubleDeckers, value: trailerType.doubleDeckers },
      ],
    },
    companiesAssessments: {
      title: "Which companies have you had assessments for?",
      value: getVal("companiesAssessments"),
      type: "table",
      tableDetails: {
        columns: ["Company", "Date", "Certificate"],
        unnamedRows: 4,
      },
    },
    stoppedByDVSAorVOSA: {
      title: "Have you ever been stopped by DVSA/VOSA?",
      value: getVal("stoppedByDVSAorVOSA"),
      type: "radio",
      radioOptions: ["Yes", "No"],
    },
    stoppedByDVSAorVOSADetails: {
      title: "Please state",
      value: getVal("stoppedByDVSAorVOSADetails"),
      dependOn: [
        {
          fieldKey: "stoppedByDVSAorVOSA",
          allowedValues: ["Yes"],
        },
      ],
    },
    otherHgvDrivers: {
      title: "Do you know any other HGV drivers looking for work?",
      value: getVal("otherHgvDrivers"),
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postDrivingFormFunc(
      "skillsAndQualifications",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/driving-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Skills and Qualifications"}
      fields={fields}
      setField={setField}
      onboardingBranch="driving"
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/driving-onboarding")}
    />
  );
};

SkillsAndQualificationsForm.propTypes = {
  appData: any,
  postDrivingFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDrivingFormFunc: postDrivingForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(SkillsAndQualificationsForm);
